"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _uuid = _interopRequireDefault(require("uuid"));
var _reactBootstrap = require("react-bootstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _overlay = _interopRequireDefault(require("../overlay"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ellipsisDefaultStyle = {
  overflow: 'hidden',
  overflowWrap: 'break-word',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordBreak: 'break-all'
};
/**
 * @extends PureComponent
 */
var ToolTipTextOverflow = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ToolTipTextOverflow, _PureComponent);
  var _super = _createSuper(ToolTipTextOverflow);
  function ToolTipTextOverflow(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ToolTipTextOverflow);
    _this = _super.call(this, props);
    _this.state = {
      hasOverflowingChildren: false,
      text: undefined
    };
    _this.updateOverflow = _this.updateOverflow.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  /**
   * check the text to show tooltip
   * @param  {object} e
   */
  (0, _createClass2.default)(ToolTipTextOverflow, [{
    key: "updateOverflow",
    value: function updateOverflow(e) {
      var el = e.target;
      var _this$state = this.state,
        hasOverflowingChildren = _this$state.hasOverflowingChildren,
        text = _this$state.text;
      // Check for overflow in both the x and y axes
      var checkOverflow = !hasOverflowingChildren && (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight);
      if (checkOverflow) {
        this.setState({
          hasOverflowingChildren: true
        });
        if (el.textContent !== text) {
          var chirdren = _lodash.default.replace(el.textContent, this.props.label, '');
          this.setState({
            text: _lodash.default.trim(chirdren)
          });
        }
      } else {
        this.setState({
          hasOverflowingChildren: false
        });
      }
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var text = this.state.text;
      var _this$props = this.props,
        _this$props$placement = _this$props.placement,
        placement = _this$props$placement === void 0 ? 'top' : _this$props$placement,
        customClass = _this$props.customClass,
        isUseOverlayTooltip = _this$props.isUseOverlayTooltip,
        style = _this$props.style,
        label = _this$props.label,
        children = _this$props.children,
        setSameAsParentWidth = _this$props.setSameAsParentWidth,
        position = _this$props.position;
      var classNameTooltip = customClass || _styles.default['tool-tip-wrapper'];
      var tooltip = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
        id: "tooltip-".concat(_uuid.default.v4()),
        className: classNameTooltip
      }, text);
      var ellipsisStyle = _objectSpread(_objectSpread({}, ellipsisDefaultStyle), style);
      var contentDisplay = /*#__PURE__*/_react.default.createElement("div", {
        style: _objectSpread(_objectSpread({}, ellipsisStyle), {}, {
          cursor: 'default'
        })
      }, label && /*#__PURE__*/_react.default.createElement("span", null, label), " ", children);
      return isUseOverlayTooltip ? /*#__PURE__*/_react.default.createElement(_overlay.default, {
        text: text,
        className: _styles.default['tool-tip-overlay-wrapper'],
        defaultShowTooltip: true,
        setSameAsParentWidth: setSameAsParentWidth,
        parentId: "".concat(children, "-tooltip"),
        position: position
      }, contentDisplay) : /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
        placement: placement,
        overlay: tooltip
      }, contentDisplay);
    }

    /**
     * render text
     * if the text is too long - make truncate and add boostrap tooltip
     * @return {element}
     */
  }, {
    key: "render",
    value: function render() {
      var hasOverflowingChildren = this.state.hasOverflowingChildren;
      var _this$props2 = this.props,
        _this$props2$style = _this$props2.style,
        style = _this$props2$style === void 0 ? {} : _this$props2$style,
        children = _this$props2.children,
        label = _this$props2.label;
      var ellipsisStyle = _objectSpread(_objectSpread({}, ellipsisDefaultStyle), style);
      return hasOverflowingChildren ? this.renderTooltip() : /*#__PURE__*/_react.default.createElement("div", {
        style: ellipsisStyle,
        onMouseEnter: this.updateOverflow
      }, label && /*#__PURE__*/_react.default.createElement("span", null, label), " ", children);
    }
  }]);
  return ToolTipTextOverflow;
}(_react.PureComponent);
ToolTipTextOverflow.propTypes = {
  // position of tooltip
  placement: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  style: _propTypes.default.shape({}),
  customClass: _propTypes.default.string,
  label: _propTypes.default.string,
  isUseOverlayTooltip: _propTypes.default.bool,
  setSameAsParentWidth: _propTypes.default.bool,
  position: _propTypes.default.shape({
    left: _propTypes.default.string,
    top: _propTypes.default.string
  })
};
ToolTipTextOverflow.defaultProps = {
  placement: undefined,
  style: undefined,
  customClass: undefined,
  label: '',
  isUseOverlayTooltip: false,
  setSameAsParentWidth: false,
  position: {
    left: '',
    top: ''
  }
};
// export ToolTipTextOverflow
var _default = ToolTipTextOverflow;
exports.default = _default;